<template>
    <div class="info-icon-wrapper" ref="wrapper">
        <i class="bi bi-info-circle info-icon" 
           @mouseenter="showTooltip = true" 
           @mouseleave="showTooltip = false"></i>
        <div v-if="showTooltip" 
             class="tooltip" 
             :style="tooltipPosition"
             @mouseenter="showTooltip = true"
             @mouseleave="showTooltip = false">
            <div class="tooltip-header">
                <strong>{{ titulo }}</strong>
            </div>
            <div class="tooltip-body">
                <p>{{ descricao }}</p>
                <div v-if="formula" class="tooltip-formula">
                    <strong>Fórmula:</strong>
                    <code>{{ formula }}</code>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GraficoInfoIcon',
    props: {
        titulo: {
            type: String,
            default: 'Informação'
        },
        descricao: {
            type: String,
            required: true
        },
        formula: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            showTooltip: false
        };
    },
    computed: {
        tooltipPosition() {
            if (!this.showTooltip || !this.$refs?.wrapper) {
                return {};
            }
            
            const rect = this.$refs.wrapper.getBoundingClientRect();
            const spacing = 10;
            const tooltipWidth = 350;
            
            // Posicionar à direita do ícone por padrão
            let left = rect.right + spacing;
            let top = rect.top;
            
            // Se não cabe à direita, colocar à esquerda
            if (left + tooltipWidth > window.innerWidth - 20) {
                left = rect.left - tooltipWidth - spacing;
            }
            
            // Garantir que não saia da tela
            if (left < 10) {
                left = 10;
            }
            if (top + 300 > window.innerHeight) {
                top = window.innerHeight - 320;
            }
            if (top < 10) {
                top = 10;
            }
            
            return {
                position: 'fixed',
                left: left + 'px',
                top: top + 'px',
                zIndex: 10000
            };
        }
    },
    watch: {
        showTooltip() {
            // Força atualização da posição quando o tooltip é exibido
            this.$forceUpdate();
        }
    }
};
</script>

<style scoped>
.info-icon-wrapper {
    position: relative;
    display: inline-block;
}

.info-icon {
    color: var(--cor-primaria);
    font-size: 1.1rem;
    cursor: help;
    margin-left: 0.5rem;
}

.info-icon:hover {
    color: var(--cor-primaria-forte);
}

.tooltip {
    background-color: var(--cor-bg);
    border: 1px solid var(--cor-separador);
    border-radius: 8px;
    box-shadow: 0 4px 12px var(--cor-cinza);
    padding: 1rem;
    min-width: 300px;
    max-width: 400px;
    z-index: 10000;
    pointer-events: none;
    white-space: normal;
    max-height: 80vh;
    overflow-y: auto;
    color: var(--cor-fonte);
}

.tooltip-header {
    margin-bottom: 0.75rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid var(--cor-separador);
}

.tooltip-header strong {
    color: var(--cor-fonte-forte);
    font-size: 1rem;
}

.tooltip-body {
    font-size: 0.9rem;
    color: var(--cor-fonte-fraca);
    line-height: 1.5;
}

.tooltip-body p {
    margin: 0 0 0.75rem 0;
}

.tooltip-formula {
    margin-top: 0.75rem;
    padding-top: 0.75rem;
    border-top: 1px solid var(--cor-separador);
}

.tooltip-formula strong {
    display: block;
    margin-bottom: 0.5rem;
    color: var(--cor-fonte-forte);
}

.tooltip-formula code {
    display: block;
    padding: 0.5rem;
    background-color: var(--cor-cinza);
    border: 1px solid var(--cor-separador);
    border-radius: 4px;
    font-size: 0.85rem;
    color: var(--cor-fonte-forte);
    white-space: pre-wrap;
    word-break: break-word;
}

:global(.dark) .tooltip {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.45);
}
</style>

